module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-upload"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLeaveConfirm),
      expression: "isLeaveConfirm"
    }],
    staticClass: "pop-wrapper"
  }, [_c('div', {
    staticClass: "pop-box"
  }, [_c('div', {
    staticClass: "pop-header clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pop-body"
  }, [_vm._v("\n        确定要离开？\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "pop-footer"
  }, [_c('a', {
    staticClass: "yes",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.confirmLeave
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('a', {
    staticClass: "no",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.cancelLeave
    }
  }, [_vm._v("取消")])])])]), _vm._v(" "), _c('div', {
    staticClass: "left-wrapper"
  }, [_c('div', {
    staticClass: "app-detail"
  }, [_c('router-link', {
    staticClass: "app-link",
    attrs: {
      "to": "/s-mart/personal_center/works/"
    }
  }, [_c('i', {
    staticClass: "icon-upper"
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('ul', {
    staticClass: "account-list list-box"
  }, _vm._l((_vm.navList), function(item, index) {
    return _c('li', {
      class: {
        'success': _vm.navList[index].curStatus === 2,
        'editing': _vm.navList[index].curStatus === 1
      },
      on: {
        "click": function($event) {
          return _vm.tabChange(index)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": item.href
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.go(item.top, index)
        }
      }
    }, [(item.curStatus === 2) ? _c('i', {
      staticClass: "bk-icon icon-check-circle-shape"
    }) : _c('i', {
      staticClass: "process"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v("\n          " + _vm._s(item.label) + "\n        ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right-wrapper"
  }, [_c('div', {
    staticClass: "right-box",
    attrs: {
      "id": "right"
    }
  }, [_c('form', {
    staticClass: "bk-form"
  }, [_c('div', {
    staticClass: "upload-panel",
    attrs: {
      "id": "anchor-1"
    }
  }, [_c('h4', [_vm._v("基础资料")]), _vm._v(" "), _c('div', {
    staticClass: "upload-form"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.input_warning('baseInformation.name')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseInformation.name.value),
      expression: "baseInformation.name.value"
    }],
    staticClass: "bk-form-input workName",
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "此处输入你上传的作品名称，建议30个字符合以内",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.baseInformation.name.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.baseInformation.name, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.baseInformation.name.isShow) ? _c('span', {
    staticClass: "tips",
    staticStyle: {
      "left": "42%"
    }
  }, [_vm._v(_vm._s(_vm.baseInformation.name.tips))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('bk-selector', {
    staticStyle: {
      "width": "168px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.baseInformation.sysType.list,
      "selected": _vm.baseInformation.sysType.selected,
      "multi-select": _vm.baseInformation.sysType.multiSelect
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInformation.sysType, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseInformation.sysType.selected === 1),
      expression: "baseInformation.sysType.selected === 1"
    }],
    staticClass: "bk-form-item"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.input_warning('baseInformation.appID')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseInformation.appID.value),
      expression: "baseInformation.appID.value"
    }],
    staticClass: "bk-form-input workId",
    staticStyle: {
      "width": "536px"
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "由小写英文字母，连接符(-)或数字组成，长度为3~16个字符，并且以字母开头",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.baseInformation.appID.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.baseInformation.appID, "value", $event.target.value)
      }, function($event) {
        return _vm.checkValidate('baseInformation.appID')
      }]
    }
  }), _vm._v(" "), (_vm.baseInformation.appID.isShow) ? _c('span', {
    staticClass: "tips",
    staticStyle: {
      "left": "42%"
    }
  }, [_vm._v(_vm._s(_vm.baseInformation.appID.tips))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.input_warning('baseInformation.funcType')
  }, [_c('bk-selector', {
    staticStyle: {
      "width": "168px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.baseInformation.funcType.list,
      "selected": _vm.baseInformation.funcType.selected,
      "multi-select": _vm.baseInformation.funcType.multiSelect
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.baseInformation.funcType, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.input_warning('baseInformation.overview')
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baseInformation.overview.value),
      expression: "baseInformation.overview.value"
    }],
    staticClass: "bk-form-textarea simpleDescription",
    staticStyle: {
      "width": "614px",
      "min-height": "70px"
    },
    attrs: {
      "maxlength": "50",
      "name": "validation_name",
      "placeholder": "请输入产品的详细介绍"
    },
    domProps: {
      "value": (_vm.baseInformation.overview.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.baseInformation.overview, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bk-form-number"
  }, [_vm._v(_vm._s(_vm.baseInformation.overview.value.length))]), _vm._v(" "), _c('span', {
    staticClass: "tips",
    staticStyle: {
      "left": "42%"
    }
  }, [_vm._v(_vm._s(_vm.baseInformation.overview.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.input_warning('baseInformation.functionPoints'),
    staticStyle: {
      "width": "614px"
    }
  }, [_c('span', {
    staticClass: "tips",
    staticStyle: {
      "left": "42%"
    }
  }, [_vm._v(_vm._s(_vm.baseInformation.functionPoints.tips))]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('div', {
    staticClass: "upload-panel",
    attrs: {
      "id": "anchor-2"
    }
  }, [_c('h4', [_vm._v("上传作品文件")]), _vm._v(" "), _c('div', {
    staticClass: "upload-form"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.input_warning('files.version')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files.version.value),
      expression: "files.version.value"
    }],
    staticClass: "bk-form-input versionNum",
    staticStyle: {
      "width": "298px"
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "例如：1.1.0"
    },
    domProps: {
      "value": (_vm.files.version.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files.version, "value", $event.target.value)
      }, function($event) {
        return _vm.checkValidate('files.version')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tips",
    staticStyle: {
      "left": "20.5%"
    }
  }, [_vm._v(_vm._s(_vm.files.version.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('div', {
    staticClass: "upload-file"
  }, [_c('div', {
    staticClass: "bk-form-input"
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('span', {
    staticClass: "bk-form-tips"
  }, [_vm._v("仅支持 .zip 格式的压缩文件")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "name": "uploadFile",
      "title": "选择文件"
    },
    on: {
      "change": _vm.handleFile
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ableToUpload),
      expression: "ableToUpload"
    }],
    staticClass: "bk-form-content"
  }, [(_vm.files.length !== 0 && _vm.files) ? _c('div', {
    staticClass: "bk-upload-ul"
  }, [_c('div', {
    staticClass: "bk-list-li"
  }, [_c('i', {
    staticClass: "bk-icon icon-file-zip"
  }), _vm._v(" "), _c('div', {
    staticClass: "bk-list-content"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.files.file.name))]), _vm._v(" "), (_vm.loadingStatus === 'start') ? _c('i', {
    staticClass: "bk-icon icon-close",
    on: {
      "click": function($event) {
        return _vm.deleteFile()
      }
    }
  }) : _c('i', {
    staticClass: "bk-icon icon-check-1"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingStatus === 'start'),
      expression: "loadingStatus === 'start'"
    }],
    staticClass: "bk-load"
  }, [_c('span', {
    class: [{
      'loading': _vm.loadingStatus === 'start'
    }, {
      'totalLoading': _vm.loadingStatus === 'complete'
    }]
  }), _vm._v(" "), _c('span')])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files.message),
      expression: "files.message"
    }],
    staticClass: "bk-form-textarea",
    staticStyle: {
      "width": "614px",
      "height": "250px"
    },
    attrs: {
      "name": "",
      "id": "",
      "placeholder": "请将你的作品该版本的功能特性和修改记录按下面例子的格式写下来， 方便你的用户/卖家能够了解版本的差异和优化的细节：\n        1. 修复了上个版本遗留的BUG 　　\n        2. 修复了因CPU核数超过32个而产生的异常 　　\n        3. 优化了不同指标类型的颜色对比度 　　\n        4. 优化了日志分割的方式 　　\n        5. 新增了Slackware发行版的支持 　　\n        6. 新增了导出Excel的功能 　　\n        7. 新增了AIX小型机系统的支持"
    },
    domProps: {
      "value": (_vm.files.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files, "message", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "upload-form upload-form-border"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    class: _vm.input_warning('files.address')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.files.address.value),
      expression: "files.address.value"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "type": "text",
      "name": "validation_name",
      "placeholder": "请在此处输入作品的线上体验地址，有助于用户直观的了解你的作品。"
    },
    domProps: {
      "value": (_vm.files.address.value)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.files.address, "value", $event.target.value)
      }, function($event) {
        return _vm.checkValidate('files.address')
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tips",
    staticStyle: {
      "left": "41%"
    }
  }, [_vm._v(_vm._s(_vm.files.address.tips))])])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "language"
    }
  }, [_c('selector', {
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.files.devLanguage.list,
      "selected": _vm.files.devLanguage.selected,
      "multi-select": _vm.files.devLanguage.multiSelect,
      "searchable": _vm.files.devLanguage.searchable
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.files.devLanguage, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "browser"
    }
  }, [_c('selector', {
    ref: "browser",
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.files.browser.list,
      "selected": _vm.files.browser.selected,
      "multi-select": _vm.files.browser.multiSelect,
      "searchable": _vm.files.browser.searchable
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.files.browser, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "surroundings"
    }
  }, [_c('selector', {
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.files.surroundings.list,
      "selected": _vm.files.surroundings.selected,
      "multi-select": _vm.files.surroundings.multiSelect,
      "searchable": _vm.files.surroundings.searchable
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.files.surroundings, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content",
    attrs: {
      "id": "interface"
    }
  }, [_c('selector', {
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "list": _vm.files.interface.list,
      "selected": _vm.files.interface.selected,
      "multi-select": _vm.files.interface.multiSelect,
      "searchable": _vm.files.interface.searchable
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.files.interface, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('tag', {
    attrs: {
      "tags": _vm.files.classification,
      "placeholder": "请输入不超过5个关键词作为标签，明确的关键词能够帮助用户更精准快速的定位到你的作品！"
    },
    on: {
      "update:tags": function($event) {
        return _vm.$set(_vm.files, "classification", $event)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "upload-panel",
    attrs: {
      "id": "anchor-3"
    }
  }, [_c('h4', [_vm._v("上传作品图片")]), _vm._v(" "), _c('works-pictures', {
    on: {
      "upPictureId": _vm.allPictureIds,
      "removePicture": _vm.removePicture
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "upload-panel",
    attrs: {
      "id": "anchor-4"
    }
  }, [_c('h4', [_vm._v("设置交易模式")]), _vm._v(" "), _c('div', {
    staticClass: "upload-form"
  }, [_c('div', {
    staticClass: "bk-form-item"
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_vm._v("收费模式：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, _vm._l((_vm.tradeMode.model), function(item, index) {
    return _c('label', {
      key: index,
      staticClass: "bk-form-radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tradeMode.selectedModel),
        expression: "tradeMode.selectedModel"
      }],
      staticClass: "bk-radio-text",
      attrs: {
        "type": "radio",
        "name": "radio1"
      },
      domProps: {
        "value": item.type,
        "checked": _vm._q(_vm.tradeMode.selectedModel, item.type)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.tradeMode, "selectedModel", item.type)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "bk-radio-text"
    }, [_vm._v(_vm._s(item.title))])])
  }), 0)]), _vm._v(" "), (_vm.tradeMode.selectedModel === 0) ? _c('div', [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(18), _vm._v(" "), _c('bk-selector', {
    staticStyle: {
      "width": "310px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.tradeMode.openSource.list,
      "selected": _vm.tradeMode.openSource.selected
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.tradeMode.openSource, "selected", $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(19), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('bk-selector', {
    staticStyle: {
      "width": "310px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.tradeMode.support.list,
      "selected": _vm.tradeMode.support.selected
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.tradeMode.support, "selected", $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(20), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tradeMode.freeUrl),
      expression: "tradeMode.freeUrl"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "614px"
    },
    attrs: {
      "type": "url",
      "placeholder": "请选择"
    },
    domProps: {
      "value": (_vm.tradeMode.freeUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tradeMode, "freeUrl", $event.target.value)
      }
    }
  })])])]) : (_vm.tradeMode.selectedModel === 1) ? _c('div', [_c('div', {
    staticClass: "bk-form-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._m(21), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tradeMode.price),
      expression: "tradeMode.price"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "type": "number",
      "name": "validation_name",
      "placeholder": "建议售价 ¥20"
    },
    domProps: {
      "value": (_vm.tradeMode.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tradeMode, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('bk-selector', {
    staticStyle: {
      "width": "310px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.tradeMode.support.list,
      "selected": _vm.tradeMode.support.selected
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.tradeMode.support, "selected", $event)
      }
    }
  })], 1)])]) : (_vm.tradeMode.selectedModel === 2) ? _c('div', [_c('div', {
    staticClass: "bk-form-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._m(23), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tradeMode.price),
      expression: "tradeMode.price"
    }],
    staticClass: "bk-form-input",
    staticStyle: {
      "width": "308px"
    },
    attrs: {
      "type": "number",
      "name": "validation_name",
      "placeholder": "建议售价 2000G"
    },
    domProps: {
      "value": (_vm.tradeMode.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tradeMode, "price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-item"
  }, [_vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('bk-selector', {
    staticStyle: {
      "width": "310px",
      "display": "inline-block"
    },
    attrs: {
      "list": _vm.tradeMode.support.list,
      "selected": _vm.tradeMode.support.selected
    },
    on: {
      "update:selected": function($event) {
        return _vm.$set(_vm.tradeMode.support, "selected", $event)
      }
    }
  })], 1)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "upload-form upload-action"
  }, [_c('a', {
    class: ['bk-button', 'bk-primary', {
      'is-loading': _vm.saveFlag === false
    }],
    attrs: {
      "id": "submit",
      "title": "提交"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("提交")])]), _vm._v(" "), _c('a', {
    staticClass: "bk-button bk-return",
    attrs: {
      "title": "返回"
    },
    on: {
      "click": _vm.leave
    }
  }, [_c('span', [_vm._v("返回")])])])])])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "app-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../images/personal_center/icon-upload2.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("上传作品")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 作品名称：\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 作品类型：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 应用ID：\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 功能类型：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 简要概述：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 功能点描述：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "614px"
    }
  }, [_c('script', {
    staticStyle: {
      "width": "614px",
      "height": "200px"
    },
    attrs: {
      "type": "text/plain",
      "id": "myEditor"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 版本号：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 版本文件：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 相关信息：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 体验地址：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 开发语言：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 浏览器兼容：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 部署环境：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 界面语言：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 分类标签：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bk-form-item",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 收费价格：")]), _vm._v(" "), _c('div', {
    staticClass: "bk-form-content"
  }, [_c('span', {
    staticClass: "bk-form-span",
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("免费")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 开源协议：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 服务支持：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 开源链接：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }, [_vm._v("*")]), _vm._v(" 收费价格：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 服务支持：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 收费价格：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "bk-label"
  }, [_c('span', {
    staticClass: "bk-label-required"
  }), _vm._v(" 服务支持：")])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0ee12601!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/personal_center/works/user_upload.vue
// module id = PfiQ
// module chunks = 16